module.exports = __webpack_public_path__ + "static/media/S10_black.af8bc2d1.png";